<template>
    <div class="modal-card card">
        <form @submit.prevent="onFormSubmit()">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Delete Entitlement Discounts</h4>
                <!-- Close -->
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
            </div>
            <div class="card-body">
                <div v-if="error" class="alert alert-danger" role="alert">
                    {{ error }}
                </div>
                <p>Are you sure you want to delete the following discounts?</p>
                <ul class="list-group list-group-sm">
                    <li v-for="item in modalData" :key="item.discount_id" class="list-group-item">
                        {{ item.entitlement_label }}: {{ item.discount_label }}
                        <span class="text-body-secondary">({{ item.effective_date }} to {{ item.end_date }})</span>
                    </li>
                </ul>
            </div>
            <div class="card-footer text-end">
                <button class="btn btn-danger" :disabled="deleteInProgress">
                    <div
                        v-if="deleteInProgress"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        >
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else>Delete</div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            error: "",
            deleteInProgress: false
        };
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    name: "DeleteEntitlementDiscounts",
    methods: {
        ...mapActions("admin", {
            deleteEntitlementDiscount: "deleteEntitlementDiscount",
        }),
        async onFormSubmit() {
            const cid = this.$route.params.id;
            this.error = "";
            this.deleteInProgress = true;
            try {
                for (const item of this.modalData) {
                    await this.deleteEntitlementDiscount({ cid, discountId: item.discount_id });
                }
            } catch (error) {
                this.error = (error.response && error.response.data && error.response.data.error) || error.message;
                // some may have been deleted before the failure
                this.$store.dispatch("admin/fetchEntitlementDiscounts", cid);
                return;
            } finally {
                this.deleteInProgress = false;
            }
            this.$store.dispatch("addToast", {
                message: "Entitlement discounts deleted successfully.",
                type: "success",
            });
            this.$store.dispatch("hideModal");
            this.$store.dispatch("admin/fetchEntitlementDiscounts", cid);
        },
    },
};
</script>

<style>
</style>
